module.exports = __webpack_public_path__ + "static/media/stockfinder.e99a2dd7.png";